import Legal from './Legal'
import Privacy from './Privacy'

const legalPages = {
    Legal,
    Privacy
}

export default legalPages